export default "__VITE_ASSET__BxYPTada__"